<template>
  <v-select
    class="bg-gray-200 rounded mt-1 p-1"
    v-model="selectedConfig"
    :options="classConfigurationTemplates"
    :reduce="option => option.class_config"
    label="show_template_identifier"
    :clearable="false"
    @input="configSelected"
  >
  </v-select>
</template>

<script>
export default {
  data () {
    return {
      classConfigurationTemplates: [],
      selectedConfig: null
    }
  },
  methods: {
    configSelected () {
      this.$emit('configChange', this.selectedConfig)
    }
  },
  mounted () {
    this.$store.state.apiInstance.get(`/data/showTemplates?_sort=species&_filter=deleted_at is null`)
      .then(response => {
        this.classConfigurationTemplates = response.data
      })
  }
}
</script>

<style>

</style>
